module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "J_DownLoadModule"
    }
  }, [_c('div', {
    staticClass: "downloadbox",
    class: {
      none: _vm.isHide
    }
  }, [_vm._m(0), _vm._m(1), _c('a', {
    staticClass: "download",
    on: {
      "click": _vm.openclient
    }
  }, [_vm._v("下载APP")]), _c('a', {
    staticClass: "close",
    on: {
      "click": _vm.closeDownLoadbottom
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/closed.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "downloadpage"
  }, [_c('div', {
    staticClass: "downloadlayer"
  }, [_c('div', {
    staticClass: "layercon"
  }, [_c('div', {
    staticClass: "layerpic"
  }, [_c('a', {
    on: {
      "click": _vm.openclient
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/appdownload.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "layerclosed"
  }, [_c('a', {
    on: {
      "click": _vm.closeDownLoad
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/closed.png")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('a', {
    on: {
      "click": _vm.openclient
    }
  }, [_vm._v("下载APP")])])])]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "text"
  }, [_vm._v("茄子手机客户端"), _c('br'), _vm._v("微笑生活，一手掌握")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download-preview",
    attrs: {
      "id": "J_DownloadPreview"
    }
  }, [_c('div', {
    staticClass: "download-preview-img"
  }, [_c('img', {
    attrs: {
      "src": "http://shop.eetop.com/tpl/static/tpl/tc/img/guide.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "download-preview-desc"
  }, [_vm._v("\n    微信用户请戳右上角按钮， 选择"), _c('img', {
    attrs: {
      "src": "http://shop.eetop.com/tpl/static/tpl/tc/img/net.png"
    }
  }), _vm._v("在浏览器中打开\n  ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-d1b4e6b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DownloadApp.vue
// module id = 204
// module chunks = 1